import { TypeChecker } from '@attain-apps/type-guards'

/**
 * Full union of allowed values. Cannot include objects or arrays, as that would
 * lead to overlap between Fn and Primitive
 */
type AllowedPrimitive = string | number | boolean | null

/**
 * Primitive value that can be used in an expression
 *
 * TODO: replace definition with {@link Primitive.Correct}
 */
export type Primitive<T = any> = AllowedPrimitive
export namespace Primitive {
  export const isPrimitive: TypeChecker<Primitive> = TypeChecker.Factory.lazy(
    () =>
      TypeChecker.Factory.union(
        TypeChecker.isString,
        TypeChecker.isNumber,
        TypeChecker.isBoolean,
        TypeChecker.isNull,
      ),
  )

  // https://github.com/microsoft/TypeScript/issues/55161
  /**
   * NOTE: this is the correct implementation of {@link Primitive}, but due to the
   * above issue, using the below implementation will make Primitive invariant
   * with T, and transitively Query invariant with T, which is just not viable.
   * However, if that issue is ever resolved, we should replace Primitive's
   * definition with this definition, and then remove this type (and address any references to this type)
   */
  export type Correct<T> =
    // T = any -> any of AllowedPrimitive
    If.IsAny<
      T,
      AllowedPrimitive,
      T extends AllowedPrimitive
        ? Extract<T, AllowedPrimitive>
        : unknown extends T // T = unknown -> any of AllowedPrimitive
          ? AllowedPrimitive
          : never
    >
}
